import generateService from './generator'

function service(endpoint) {
    const base = generateService(endpoint);

    return {
        fetchAll: base.fetchAll,
        store: base.store,
        destroy: base.destroy
    }
}

export default service
